import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full bg-white" data-id="element-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-32">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-6" data-id="element-33">
            Esto No Es Solo un Libro. Es un Sistema Completo.
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-34">
            Y para que tengas absolutamente todo lo que necesitas para llegar
            listo el día de tu entrevista, cuando compres hoy recibirás también
            estos dos bonos completamente gratis:
          </p>
        </motion.div>

        <div className="space-y-16" data-id="element-35">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#F7F5F0] rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-36">
            <div className="grid md:grid-cols-2 gap-8 items-center p-8 sm:p-12" data-id="element-37">
              <div className="order-2 md:order-1" data-id="element-38">
                <div className="inline-flex items-center gap-2 bg-[#1B2A4A] text-white px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-39">
                  <GiftIcon className="w-4 h-4 text-[#C9A84C]" data-id="element-40" />
                  <span data-id="element-41">BONUS #1</span>
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-4" data-id="element-42">
                  Preguntas Actualizadas 2026 — Banco Bilingüe de Preguntas y
                  Respuestas Precisas
                </h3>
                <div className="mb-6" data-id="element-43">
                  <span className="text-gray-500 line-through text-lg mr-2" data-id="element-44">
                    Valor real: $17 USD
                  </span>
                  <span className="text-[#C9A84C] font-bold text-xl" data-id="element-45">
                    Hoy: GRATIS
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-46">
                  Un documento completo con todas las preguntas y respuestas
                  organizadas en formato bilingüe. En el lado izquierdo la
                  pregunta en inglés tal como la dirá el oficial. En el lado
                  derecho la misma pregunta en español para que tu cerebro la
                  procese sin bloqueos. Diseñado para repasar en cualquier
                  momento y en cualquier lugar. Sin internet. Sin audio. Solo tú
                  y las respuestas que necesitas dominar antes de entrar a esa
                  oficina.
                </p>
              </div>
              <div className="order-1 md:order-2 flex justify-center" data-id="element-47">
                <img src="https://cdn.magicpatterns.com/uploads/onq38wYPTYXiX3pJk62UM9/Portada_bonus_1.png" alt="Portada Bonus 1" className="w-full max-w-sm rounded-lg shadow-xl" data-id="element-48" />
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#F7F5F0] rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-49">
            <div className="grid md:grid-cols-2 gap-8 items-center p-8 sm:p-12" data-id="element-50">
              <div className="flex justify-center" data-id="element-51">
                <img src="https://cdn.magicpatterns.com/uploads/rS4VnxqiHeP3H4nvLrcXZ1/Portada_bonus_2.png" alt="Portada Bonus 2" className="w-full max-w-sm rounded-lg shadow-xl" data-id="element-52" />
              </div>
              <div data-id="element-53">
                <div className="inline-flex items-center gap-2 bg-[#1B2A4A] text-white px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-54">
                  <GiftIcon className="w-4 h-4 text-[#C9A84C]" data-id="element-55" />
                  <span data-id="element-56">BONUS #2</span>
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-4" data-id="element-57">
                  Preguntas Actualizadas 2026 — Audio Bilingüe de Práctica con
                  Voz Nativa
                </h3>
                <div className="mb-6" data-id="element-58">
                  <span className="text-gray-500 line-through text-lg mr-2" data-id="element-59">
                    Valor real: $27 USD
                  </span>
                  <span className="text-[#C9A84C] font-bold text-xl" data-id="element-60">
                    Hoy: GRATIS
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-61">
                  Una simulación de audio completa narrada por una voz nativa en
                  inglés con tiempos de pausa reales para que practiques tus
                  respuestas en voz alta. Exactamente como si estuvieras frente
                  al oficial. Preparación real, claridad y éxito en la
                  entrevista. Puedes usarlo mientras manejas, cocinas o
                  descansas. Tu oído se entrena aunque no estés sentado
                  estudiando.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}